import React from 'react';
import ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';

import './package-configurations';
import './polyfill';
import { initBrowserSentry } from './sentry';

import BrowserApp from './BrowserApp';

initBrowserSentry();

const isSSR = window.isSSR || false;
const root = document.getElementById('root');

/**
 * Use loadable ready to ensure all chunks are loaded before hydrating the app.
 * We use server side rendering for crawlers, else block is used for CSR
 * for regular client side rendering.
 * `loadableReady` throws a console warning if the function is used in CSR context.
 */

if (isSSR) {
  loadableReady(() => {
    ReactDOM.hydrate(<BrowserApp />, root);
  });
} else {
  ReactDOM.hydrate(<BrowserApp />, root);
}
